import classNames from 'classnames'

import AnimatedCard from '../ui/AnimatedCard/AnimatedCard'
import Button from '../ui/Button/Button'
import Image from '../ui/Image/Image'
import CareerBreadcrumb from './CareerBreadcrumb'
import { viewDocument } from '../../utils'

import styles from './CareerLayout.module.scss'
import arrow from '../../assets/images/arrowUpRight.svg'
import briefcase from '../../assets/images/briefcase.svg'
import users from '../../assets/images/users.svg'

function VacancyCard({ vacancy }) {
  const viewPdfHandler = (pdfDetails = {}) => {
    viewDocument(pdfDetails?.url || '')
  }
  const renderBottomAnimation = (item) => (
    <div className={classNames(' relative flex', styles.actionWrapper)}>
      <Button
        classname={styles.button}
        text={vacancy.button_label}
        aria-label={vacancy.button_label}
        onClick={() => viewPdfHandler(item?.fileinfo)}
      >
        <img src={arrow} alt={'View'} className="block cursor-pointer" />
      </Button>
    </div>
  )
  return (
    <AnimatedCard
      cardClassname={styles.rootCardContainer}
      renderBottomAnimation={() => renderBottomAnimation(vacancy)}
      bottomAnimationClassName={classNames(styles.bottomAnimation)}
    >
      <div className={styles.leftContainer}>
        <div className={styles.vacancyTitleContainer}>
          <span className={styles.vacancyTitle}>{vacancy?.job_title}, </span>
          <span className={styles.vacancyLocation}>
            {vacancy?.job_location}
          </span>
        </div>
        <CareerBreadcrumb categories={vacancy.category_breadcrumb} />
      </div>
      <div className={styles.rightContainer}>
        <div className={styles.numberContainer}>
          <Image
            src={briefcase}
            alt={`${vacancy?.job_experience} ${vacancy?.job_experience_title}`}
          />
          <span>{`${vacancy?.job_experience} ${vacancy?.job_experience_title}`}</span>
        </div>
        <div className={styles.numberContainer}>
          <Image
            src={users}
            alt={`${vacancy?.vacancy} ${vacancy?.vacancy_title}`}
          />
          <span>{`${vacancy?.vacancy} ${vacancy?.vacancy_title}`}</span>
        </div>
      </div>
    </AnimatedCard>
  )
}

export default VacancyCard
